export default "__VITE_ASSET__b625771c__"